import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, Loader2, Building2 } from "lucide-react";
import AdminLayout from "@/components/admin/AdminLayout";
import { apiClient, formatErr } from "@/lib/api";

const FIELDS = [
  { key: "intestatario", label: "Intestatario" },
  { key: "iban", label: "IBAN", mono: true },
  { key: "banca", label: "Banca" },
  { key: "bic", label: "BIC / SWIFT", mono: true },
  { key: "causale", label: "Causale di default" },
];

export default function AdminSettings() {
  const [form, setForm] = useState({
    intestatario: "", iban: "", banca: "", bic: "", causale: "",
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await apiClient.get("/admin/settings");
        setForm(data);
      } catch (e) {
        toast.error(formatErr(e));
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await apiClient.put("/admin/settings", form);
      toast.success("Impostazioni salvate");
    } catch (e) {
      toast.error(formatErr(e));
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <AdminLayout title="Impostazioni" subtitle="Setup">
        <div className="flex justify-center py-20">
          <Loader2 className="animate-spin text-[#E63946]" size={28} />
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout title="Impostazioni" subtitle="Setup">
      <div className="max-w-2xl">
        <div className="bg-white border border-zinc-200">
          <div className="px-6 py-4 border-b border-zinc-200 flex items-center gap-3">
            <Building2 size={16} className="text-[#E63946]" />
            <div className="text-[10px] uppercase tracking-widest font-mono text-[#E63946]">
              Coordinate Bonifico Predefinite
            </div>
          </div>
          <div className="p-6 space-y-4">
            <p className="text-zinc-600 text-sm leading-relaxed">
              Questi dati verranno usati come <strong className="text-zinc-900">preset</strong> quando
              invii le coordinate bonifico ai clienti. Potrai sempre modificarli prima dell&apos;invio.
            </p>
            {FIELDS.map((f) => (
              <div key={f.key}>
                <label className="block text-[10px] uppercase tracking-widest font-mono text-zinc-500 mb-2">
                  {f.label}
                </label>
                <input
                  value={form[f.key] || ""}
                  onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
                  data-testid={`setting-${f.key}`}
                  className={`w-full bg-white border border-zinc-300 px-4 py-3 text-zinc-900 focus:outline-none focus:border-[#E63946] transition-colors text-sm ${
                    f.mono ? "font-mono tracking-wide" : ""
                  }`}
                />
              </div>
            ))}
            <button
              onClick={save}
              disabled={saving}
              data-testid="settings-save"
              className="inline-flex items-center gap-3 px-6 py-3.5 bg-[#E63946] hover:bg-[#c81d25] disabled:opacity-50 text-white font-bold uppercase tracking-widest text-xs transition-colors"
            >
              {saving ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />}
              Salva Impostazioni
            </button>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
